var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-6 pb-10"},[_vm._m(0),_c('FenceMaterialsBill',{attrs:{"fence":_vm.fenceModules}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col lg:flex-row justify-between items-center mb-6"},[_c('h1',{staticClass:"page-title"},[_vm._v("Kit gard")])])
}]

export { render, staticRenderFns }